import React, { useCallback, useMemo } from "react";
import {
  Line, Bar, ReferenceLine, Area
} from 'recharts';
import { getChartColors, getImportantChartColors, renderCommonChart } from './commonChart';
import { formatDate } from "@/utils/format";
import { Item } from "@/api";
import { s, u } from "node_modules/@tanstack/query-core/build/modern/hydration-B_mC2U5v";


interface ISummaryChartProps {
  items: Item[];
  inventories: Record<Item["品目ID"], number[]>;
  shipments: Record<Item["品目ID"], number[]>;
  productions: Record<Item["品目ID"], number[]>;
  日付: string[];
  compare?: boolean;
  simple?: boolean;
}

const SummaryChart: React.FC<ISummaryChartProps> = ({
  items,
  inventories,
  shipments,
  productions,
  日付,
  compare = false,
  simple = false,
}) => {
  const dates = 日付.map(d=>formatDate(d));

  /**
   * 与えられたデータから以下を計算する
   * - 在庫が0以下になった品目数
   * - 在庫が上限を超えた品目数
   * - 在庫が下限を下回った品目数
   */
  const summaryData = useMemo(() => {
    return dates.map((date, index) => {
      const dataPoint: Record<string,string | number> = { date };
      dataPoint['在庫切れ品目数'] = items.filter(item => inventories[item.品目ID][index] < 0).length;
      dataPoint['在庫切れ個数'] = items.reduce((sum, item) => sum + (inventories[item.品目ID][index] > 0 ? 0 : inventories[item.品目ID][index] * -1), 0);
      dataPoint['在庫上限超え品目数'] = items.filter(item => inventories[item.品目ID][index] > item.在庫上限.value).length;
      dataPoint['在庫下限未満品目数'] = items.filter(item => inventories[item.品目ID][index] < item.在庫下限.value).length;
      dataPoint['生産数合計'] = items.reduce((sum, item) => sum + productions[item.品目ID]?.[index], 0);
      if(compare){
        dataPoint['在庫切れ品目数(初期計画)'] = items.filter(item => inventories[`${item.品目ID}_old`][index] < 0).length;
        dataPoint['在庫切れ個数(初期計画)'] = items.reduce((sum, item) => sum + (inventories[`${item.品目ID}_old`][index] > 0 ? 0 : inventories[`${item.品目ID}_old`][index] * -1), 0);
        dataPoint['在庫上限超え品目数(初期計画)'] = items.filter(item => inventories[`${item.品目ID}_old`][index] > item.在庫上限.value).length;
        dataPoint['在庫下限未満品目数(初期計画)'] = items.filter(item => inventories[`${item.品目ID}_old`][index] < item.在庫下限.value).length;
        dataPoint['生産数合計(初期計画)'] = items.reduce((sum, item) => sum + productions[`${item.品目ID}_old`]?.[index], 0);
      }
      return dataPoint;
    });
  }, [items, inventories, shipments, productions, dates,compare]);

  console.log("summaryData",summaryData)

  const charts = useMemo(() => {
    let index= 0;
    const itemId = `summary`
    return [
    (
      <Bar
      dataKey="生産数合計"
      fill={getImportantChartColors(index++)}
      fillOpacity={0.5}
      yAxisId="right"
      name="生産数合計"
      />
    ),
    compare ? (
      <Bar
        dataKey="生産数合計(初期計画)"
        fill={getImportantChartColors(index++)}
        fillOpacity={0.5}
        yAxisId="right"
        name="生産数合計(初期計画)"
      />
    ) : null,
    ["在庫切れ品目数", "在庫切れ個数","在庫上限超え品目数", "在庫下限未満品目数"].map((key, i) => {
        if(simple && i > 1) return null;
        return <Line
          type="monotone"
          dataKey={key}
          stroke={getChartColors(index++)}
          strokeWidth={2}
          yAxisId={i == 1 ? "right" : "left"}
          name={key}
        />
    }),
    compare ?
    ["在庫切れ品目数(初期計画)","在庫切れ個数(初期計画)","在庫上限超え品目数(初期計画)", "在庫下限未満品目数(初期計画)"].map((key, i) => {
        if(simple && i > 1) return null;
        return <Line
          type="monotone"
          dataKey={key}
          stroke={getChartColors(index++)}
          strokeWidth={2}
          yAxisId={i == 1 ? "right" : "left"}
          name={key}
        />
    }) : null,
  ].flat().filter(Boolean)
  }, [compare,simple]);

  return renderCommonChart(summaryData, charts, false, undefined, undefined, true,{
    left: "品目数",
    right: "生産数合計",
  }) // 第6引数にtrueを追加して2軸を有効化
};

export default SummaryChart;
